


















































import Vue from "vue";
import { ROLE, INIT_USER } from "@/common/constant";
import { UserManagerService } from "@/common/api";
import PaginateModel from "@/model/paginate";
import { UserManagementUserDTO } from "@/common/api/models/UserManagementUserDTO";
import Component from "vue-class-component";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import UserAdd from "@/sites/admin/pages/users/add.vue";
import QNotify from "@/common/qNotify";
import { namespace } from "vuex-class";

const auth = namespace("Auth");

@Component({
  name: "UserIndex",
  components: {
    QTableHeader,
    QPaginate,
    UserAdd,
  },
})
export default class UserIndex extends Vue {
  @auth.Getter
  getUsingGroup!: string;
  public users: UserManagementUserDTO[] = null;

  public initSearch = {
    sort: "created_at",
    direction: "asc",
    perPage: 50,
    currentPage: 1,
  };

  public searchParams = {};
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
    perPage: 50,
  });

  public headers = [
    { id: "created_at", name: "登録日", order: "asc" },
    { id: "name", name: "ユーザー名", order: "" },
    { id: "role", name: "権限" },
    { id: "group_name", name: "所属グループ名" },
    { id: "email", name: "メールアドレス" },
    { id: "", name: "" },
  ];
  mounted() {
    this.filter();
  }
  public filter(): void {
    let query = this.$router.currentRoute.query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    query = {
      ...this.initSearch,
      ...query,
      ...{
        groupId: this.getUsingGroup,
      },
    };
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    const result = await UserManagerService.adminUser(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
      perPage: result.data.paginator.perPage,
    });
    this.users = result.data.users;
  }

  public addUser() {
    (this.$refs.userAdd as UserAdd).show();
  }

  public closeUserAdd() {
    this.doSearch();
  }

  public isInitUser(user) {
    return user.email == INIT_USER.EMAIL && user.role == INIT_USER.ROLE;
  }

  public getRoleName(role) {
    return ROLE[role];
  }

  async deleteUser(user, index) {
    this.$modal.showDelete({
      text: `削除を実行します。この操作は取り消せません。`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let result;
        try {
          result = await UserManagerService.adminUserDelete({
            userId: user.id,
            groupId: user.group_id,
            role: user.role,
          });
        } catch (error) {
          result = error;
        }

        if (result.status == "success") {
          this.users.splice(index, 1);
        } else {
          QNotify.error({
            text: result.body.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }
}
